<template>
  <div>
    <el-card class="box-card">
      <el-form ref="queryParams" :model="queryParams" :inline="true">
        <el-form-item label="类型" prop="platForm">
          <el-select v-model="queryParams.type" size="small" style="width: 150px" placeholder="请选择" @change="changeHeight">
            <el-option
              v-for="item in platForm"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
        </el-form-item>
      </el-form>

      <div ref="chartContainer" :style="{width: '100%', height: minHeight}" />
    </el-card>
  </div>
</template>

<script>
import echarts from 'echarts'
import { getNewUserStat } from '@/api/statistics/user_remain'
import { dateStrTodate } from '@/utils'

export default {
  name: 'NewUserLoginStat',
  props: {
    typ: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      maxHeight: '800px',
      minHeight: '500px',
      platForm: [
        { label: '登录方式', value: 1 },
        { label: '语言类型', value: 2 },
        { label: '国家分布', value: 3 },
        { label: '客户端类型分布', value: 4 }
      ],
      country: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        level: 1,
        type: 1
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.initChart()
    },
    initChart() {
      const chart = echarts.init(this.$refs.chartContainer)
      const option = {
        title: {
          text: '新增玩家分布'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0 // 设置为0，表示所有的标签都显示
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {}
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      chart.setOption(option)
      let dateArr = []
      let loginType = {}
      let subTitle = '新增'
      if (this.typ === 2) {
        subTitle = '活跃'
      }
      let title = subTitle + '玩家登录方式分布'
      this.queryParams.level = this.typ
      getNewUserStat(this.queryParams).then(res => {
        this.queryParams.startDate = res.data.req.startDate
        this.queryParams.endDate = res.data.req.endDate
        const country = res.data.countryMap
        const loginTypeArr = res.data.loginTypeMap
        const lang = res.data.langMap
        const platform = { 1: '安卓', 2: 'IOS', 3: 'TG' }
        switch (this.queryParams.type) {
          case 1:
            title = subTitle + '登录方式分布';
            [dateArr, loginType] = this.handleData('ad_channel', res.data.data)
            break
          case 2:
            title = subTitle + '玩家语言分布';
            [dateArr, loginType] = this.handleData('lang', res.data.data)
            break
          case 3:
            title = subTitle + '玩家国家分布';
            [dateArr, loginType] = this.handleData('country', res.data.data)
            break
          case 4:
            title = subTitle + '玩家客户端分布';
            [dateArr, loginType] = this.handleData('channel', res.data.data)
            break
        }

        for (const i in loginType) {
          let title = i
          switch (this.queryParams.type) {
            case 1:
              if (loginTypeArr[i] !== undefined) {
                title = loginTypeArr[i]
              }
              break

            case 4:
              if (platform[i] !== undefined) {
                title = platform[i]
              }
              break

            case 2:
              if (lang[i] !== undefined) {
                title = lang[i]
              }
              break

            case 3:
              if (country[i] !== undefined) {
                title = country[i]
              }
              break
          }

          const series = {
            name: title,
            data: loginType[i],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
          option.legend.data.push(title)
          option.series.push(series)
        }
        option.title.text = title
        option.xAxis.data = dateArr
        chart.setOption(option, true)
      })
    },
    handleData(key, data) {
      const tempDateArr = {}
      const dateArr = []
      const loginType = {}
      data.forEach(item => {
        const d = dateStrTodate(item.date)
        tempDateArr[d] = d
        if (loginType[item[key]] === undefined) {
          loginType[item[key]] = []
        }
        loginType[item[key]].push(item.count)
      })

      for (const d in tempDateArr) {
        dateArr.push(d)
      }

      return [dateArr, loginType]
    },
    changeHeight(v) {

    }
  }
}
</script>

<style scoped>

</style>
